import { render, staticRenderFns } from "./helpcenterindex.vue?vue&type=template&id=6c15ba81&scoped=true"
import script from "./helpcenterindex.vue?vue&type=script&lang=js"
export * from "./helpcenterindex.vue?vue&type=script&lang=js"
import style0 from "./helpcenterindex.vue?vue&type=style&index=0&id=6c15ba81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15ba81",
  null
  
)

export default component.exports